import { useTranslation } from "react-i18next";
import { Link, matchPath, useLocation } from "react-router-dom";

import { SidebarMenuButton, SidebarMenuItem } from "@/components/ui/sidebar";
import type { SidebarNavigationItem } from "./types";

type SidebarNavItemProps = {
  item: SidebarNavigationItem;
};

export const isItemActive = (pathname: string, { to, exact }: SidebarNavigationItem) =>
  !!matchPath(pathname, { path: to, exact });

export const SidebarNavItem = ({ item }: SidebarNavItemProps) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { icon: Icon, labelKey, to } = item;
  const label = t(labelKey);

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        isActive={isItemActive(pathname, item)}
        tooltip={label}
        className="h-10 gap-3 px-3 text-base text-neutral-700 data-[active=true]:bg-primary-100 data-[active=true]:font-semibold data-[active=true]:text-primary-700 group-data-[collapsible=icon]:size-10! group-data-[collapsible=icon]:p-2.5! [&>svg]:size-5"
      >
        <Link to={to}>
          <Icon />
          <span>{label}</span>
        </Link>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
};
